import { Box, IconButton } from '@mui/material';
import { ViewListRounded, ViewModuleRounded } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

const ViewModeToggle = ({
  viewMode,
  onChangeViewMode,
  modes = [
    { value: 'list', Icon: ViewListRounded },
    { value: 'grid', Icon: ViewModuleRounded },
  ],
  sx: sxProp,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', gap: '10px', ...sxProp }}>
      {modes.map(({ value, Icon }) => (
        <IconButton key={value} onClick={() => onChangeViewMode(value)} sx={{ p: 0 }}>
          <Icon
            sx={{
              fontSize: 24,
              color: viewMode === value ? theme.palette.black[9] : theme.palette.black[3],
            }}
          />
        </IconButton>
      ))}
    </Box>
  );
};

export default ViewModeToggle;
